<div class="comment-info-popup-root">
  <div class="header">
    <div>{{this.labels.notes}}</div>
    <button
      id="close-comment-dialog-icon"
      mat-icon-button
      class="close-button"
      (click)="emitCloseClick()"
    >
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <app-input [textarea]="true" id="note-input" [control]="form.controls.note" label="{{this.labels.note}}" [disabled]="!canSave || viewOnly">

  </app-input>
  <div class="button-area" *ngIf="canSave">
    <button mat-raised-button *ngIf="!viewOnly" color="primary" (click)="emitSaveClick()" [disabled]="form.invalid">{{this.labels.saveNote}}</button>
  </div>
</div>
